import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MoveForm } from "@/components/ItemActions";

export const moveMany = async (barcodes, location_id) => {
  let ok = 0;
  for (const barcode of barcodes) {
    try {
      await api.post("/moves", { barcode, location_id });
      ok += 1;
    } catch (e) {
      toast.error(`${barcode}: ${errMsg(e)}`);
    }
  }
  if (ok) toast.success(`${ok} bottle${ok > 1 ? "s" : ""} placed`);
};

export const BulkMoveDialog = ({ barcodes, onClose, onDone }) => (
  <Dialog open={!!barcodes.length} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-md bg-[#161214] border-[#2E252A]" data-testid="bulk-move-dialog">
      <DialogHeader><DialogTitle className="font-serif text-2xl">Place {barcodes.length} bottle{barcodes.length > 1 ? "s" : ""}</DialogTitle></DialogHeader>
      <MoveForm onSave={async (loc) => { await moveMany(barcodes, loc); onClose(); onDone(); }} />
    </DialogContent>
  </Dialog>
);

export const BulkPlace = ({ bottles, onDone }) => {
  const [sel, setSel] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setSel(bottles.map((b) => b.barcode));
  }, [bottles]);
  if (!bottles.length) return null;
  const toggle = (c) => setSel((s) => (s.includes(c) ? s.filter((x) => x !== c) : [...s, c]));
  return (
    <div className="rounded-xl border border-dashed border-[#E5A93C]/60 bg-[#161214] p-5 mb-6 rise" data-testid="bulk-place">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
        <p className="text-sm text-[#E5A93C]"><MapPin className="w-4 h-4 inline mr-1.5" />Give a location to the bottles without one</p>
        <div className="flex gap-2">
          <Button size="sm" variant="ghost" onClick={() => setSel(sel.length === bottles.length ? [] : bottles.map((b) => b.barcode))} data-testid="bulk-place-toggle-all">{sel.length === bottles.length ? "Select none" : "Select all"}</Button>
          <Button size="sm" disabled={!sel.length} onClick={() => setOpen(true)} className="bg-[#D4AF37] hover:bg-[#E5A93C] text-[#0D0A0B]" data-testid="bulk-place-button">Place {sel.length} selected</Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {bottles.map((b) => (
          <label key={b.barcode} className={`font-mono text-xs rounded border px-2 py-1 cursor-pointer transition-colors ${sel.includes(b.barcode) ? "border-[#D4AF37] text-[#F5F0EB]" : "border-[#2E252A] text-[#6E665D]"}`} data-testid={`bulk-place-item-${b.barcode}`}>
            <input type="checkbox" className="mr-1.5 accent-[#D4AF37]" checked={sel.includes(b.barcode)} onChange={() => toggle(b.barcode)} />
            {b.barcode} <span className="text-[#6E665D]">· {b.wine}</span>
          </label>
        ))}
      </div>
      <BulkMoveDialog barcodes={open ? sel : []} onClose={() => setOpen(false)} onDone={onDone} />
    </div>
  );
};
